export default "__VITE_ASSET__tRCkAPmw__"